import { PLAN_CODES, SEATS_ONLY_PRODUCT_CODE } from '../../modals/upgrade-plan/constants';
export const selectPlanByCode = (pricing, planCode) => pricing.plans.find(plan => plan.code === planCode);
export const selectPlanPrices = (pricing, planCode, intervalUnit) => {
    const plan = selectPlanByCode(pricing, planCode);
    if (!plan) {
        return [];
    }
    return plan.prices.filter(price => price.interval.unit === intervalUnit && price.active);
};
export const selectPlanSeatProduct = (pricing, planCode) => {
    var _a;
    const planSeatProducts = pricing.seatProducts.find(sp => sp.planCode === planCode);
    return (_a = planSeatProducts === null || planSeatProducts === void 0 ? void 0 : planSeatProducts.products) === null || _a === void 0 ? void 0 : _a.find(product => product.code === SEATS_ONLY_PRODUCT_CODE);
};
export const selectPlanSeatPrice = (pricing, planCode, intervalUnit) => {
    var _a;
    const seatProduct = selectPlanSeatProduct(pricing, planCode);
    return (_a = seatProduct === null || seatProduct === void 0 ? void 0 : seatProduct.prices) === null || _a === void 0 ? void 0 : _a.find(({ interval }) => (interval === null || interval === void 0 ? void 0 : interval.unit) === intervalUnit);
};
/** Features of `planCode` from the plan group whose version range covers the current pricing version. */
export const selectPlanFeatures = (pricing, planCode) => {
    var _a, _b;
    if (!pricing.pricingPlanFeatures) {
        return [];
    }
    const pricingVersion = parseFloat(pricing.pricingVersion);
    const currentGroup = pricing.pricingPlanFeatures.plan_groups
        .filter(group => pricingVersion >= parseFloat(group.version_min) && pricingVersion <= parseFloat(group.version_max))
        .pop();
    const planFeatureDetail = (_a = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.plans) === null || _a === void 0 ? void 0 : _a.find(({ plan_name }) => plan_name === planCode);
    return (_b = planFeatureDetail === null || planFeatureDetail === void 0 ? void 0 : planFeatureDetail.features) !== null && _b !== void 0 ? _b : [];
};
export const selectStarterPlan = (pricing) => selectPlanByCode(pricing, PLAN_CODES.STARTER);
export const selectStarterPrice = (pricing, intervalUnit) => selectPlanPrices(pricing, PLAN_CODES.STARTER, intervalUnit)[0];
